export default "__VITE_ASSET__CaT_9UGA__"